import { appUrl } from './config.js';
import { clearStorage } from './storage.js';
const loginPath = '/login';
/** Only a path on this origin; anything else makes `?from=` an open redirect. */
export function safeReturnPath(value) {
    // The URL parser strips tab and newline and reads `\` as `/`, so `/\host` and
    // `/<tab>/host` resolve off-origin unless they are normalized away first.
    const path = value?.replace(/[\t\n\r]/g, '');
    if (!path?.startsWith('/') || path.startsWith('//') || path.startsWith('/\\')) {
        return undefined;
    }
    return path;
}
/** Read at the moment of use — a callback is wired up before the user is on the page. */
export function currentReturnPath() {
    return safeReturnPath(new URLSearchParams(location.search).get('from'));
}
/**
 * `/login` carrying where the user was headed, and `reason=expired` when the
 * session ended under them rather than them choosing to leave. A query param is
 * the only carrier that survives the `clearStorage()` on the way out.
 */
export function loginPathReturningTo(from, reason) {
    const params = new URLSearchParams();
    const returnPath = safeReturnPath(from);
    if (returnPath) {
        params.set('from', returnPath);
    }
    if (reason) {
        params.set('reason', reason);
    }
    const query = params.toString();
    return query ? `${loginPath}?${query}` : loginPath;
}
let sessionEnding = false;
/** Latches on the way out: whatever raised after it is teardown, not news. The full page
 * load into /login is what clears it, so there is no reset to call. */
export function isSessionEnding() {
    return sessionEnding;
}
export function endSessionReturningHere() {
    sessionEnding = true;
    // Already on the login page means there is nothing to come back to.
    const returnTo = location.pathname === loginPath ? '' : `${location.pathname}${location.search}`;
    clearStorage();
    location.href = `${appUrl}${loginPathReturningTo(returnTo, 'expired')}`;
}
